module.exports = __webpack_public_path__ + "img/df2df2a.png";